module.exports = __webpack_public_path__ + "static/media/edit-solid.9a4d5fd5.svg";